import { mainColors } from '../../../../../styling/theme';

// Create a component for displaying the version number with color coding
export const VersionNumberDisplay = ({ version }: { version: string }) => {
  // Split the version number into major, minor and patch
  const versionNumbers = version.split('.');
  const major = parseInt(versionNumbers[0]) || 0;
  const minor = parseInt(versionNumbers[1]) || 0;
  const patch = parseInt(versionNumbers[2]) || 0;
  
  // Decide what color to be used based on the version number
  let backgroundColor = mainColors.Pass_darker;
  // If Edits have been made then display Amber (patch takes priority)
  if (patch > 0) {
    backgroundColor = mainColors.accentOrange;
  } else if (minor > 0) {
    // If a review is available then display blue
    backgroundColor = mainColors.mainBlue_lighter;
  }
  // Otherwise the document is published and we leave it green.
  
  return (
    <div
      className="text-white rounded-md px-1 py-0.5 font-normal"
      style={{ backgroundColor }}
    >
      {version}
    </div>
  );
};
